module.exports = __webpack_public_path__ + "media/images/team-b87d03181d0d40e2862e0494a545ee33.jpg";